import { render, staticRenderFns } from "./SocialHistory.vue?vue&type=template&id=749c32b0&"
import script from "./SocialHistory.vue?vue&type=script&lang=ts&"
export * from "./SocialHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('749c32b0')) {
      api.createRecord('749c32b0', component.options)
    } else {
      api.reload('749c32b0', component.options)
    }
    module.hot.accept("./SocialHistory.vue?vue&type=template&id=749c32b0&", function () {
      api.rerender('749c32b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/admission/SocialHistory.vue"
export default component.exports